module.exports = __webpack_public_path__ + "static/media/undraw_handcrafts_user.0e4c3aee.png";